import React from 'react';
import { IProps } from './types';
import * as S from './styles';
import ReactSlider, { Range } from 'rc-slider';

const Slider: React.FC<IProps> = (props) => {

  return (
    <S.Root
      id={`${props.id}-slider`}
      style={props.containerStyle}
    >
      <ReactSlider
        min={props.slider?.min}
        max={props.slider?.max}
        step={props.slider?.step}
        startPoint={props.slider?.startPoint}
        value={props.slider?.value}
        onChange={(e) => { props.onChange(props.id, e, false); }}
        onAfterChange={(e) => { props.onChange(props.id, e, true); }}
        railStyle={{
          height: 1,
          background: "#818181",
          ...props.slider?.railStyle
        }}
        handleStyle={{
          height: 10,
          width: 10,
          marginTop: -4,
          backgroundColor: "#c4c4c4",
          border: 0,
          ...props.slider?.handleStyle
        }}
        trackStyle={{
          height: 1,
          background: "none",
          ...props.slider?.trackStyle
        }}
        dotStyle={{
          border: 0,
          height: 5,
          width: 5,
          top: -2,
          background: "#c4c4c4",
          ...props.slider?.dotStyle
        }}
      />
    </S.Root>
  );
}

export default Slider;